import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import { buildCdDiffRows } from './cd-xml-diff';
import DiffSummary from './diff-summary';

const CdDiffSummary = ({ beforeRequestXml, afterRequestXml, beforeCars, afterCars, header }) => {
  const { rows, error } = useMemo(() => {
    try {
      return { rows: buildCdDiffRows({ beforeRequestXml, afterRequestXml, beforeCars, afterCars }) };
    } catch (e) {
      return { error: e.message };
    }
  }, [beforeRequestXml, afterRequestXml, beforeCars, afterCars]);

  if (error) {
    return (
      <>
        {header}
        <Label>{`Couldn't build the ClarionDoor summary: ${error}. The Raw tab still shows the full data.`}</Label>
      </>
    );
  }
  return <DiffSummary rows={rows} header={header} emptyMessage="No rating differences between these versions" />;
};

CdDiffSummary.propTypes = {
  beforeRequestXml: PropTypes.string.isRequired,
  afterRequestXml: PropTypes.string.isRequired,
  beforeCars: PropTypes.array,
  afterCars: PropTypes.array,
  header: PropTypes.node
};

export default CdDiffSummary;
